const MAX_TENANCY_NOTES_LENGTH = 500;

export {
    MAX_TENANCY_NOTES_LENGTH,
};
